import { http } from '.';

/**
 * v2 예약 API는 kaddie 서버가 아니라 booking 서버에서 서빙된다.
 * 운영: api.kimcaddie.com / 그 외(dev·로컬): dev-api.kimcaddie.com
 */
const getBookingApiOrigin = () => {
  const hostname = window.location.hostname;

  if (hostname === 'kaddie.golf' || hostname === 'www.kaddie.golf') {
    return 'https://api.kimcaddie.com';
  }

  return 'https://dev-api.kimcaddie.com';
};

export const getBookingLists = async (params: any) => {
  const response = await http.get(`/bookings`, { params });
  return response;
};

export const getBookingDetail = async (bookingId: string) => {
  const response = await http.get(`/bookings/${bookingId}`);
  return response;
};

export const getMyBookingLists = async (shopSeqNo: number, limit?: number, offset?: number) => {
  const params = new URLSearchParams();
  params.append('shopSeqNo', shopSeqNo.toString());

  if (limit !== undefined) {
    params.append('limit', limit.toString());
  }
  if (offset !== undefined) {
    params.append('offset', offset.toString());
  }
  const response = await http.get(`/bookings/my?${params.toString()}`);
  return response;
};

/**
 * 콜게이트: 서버가 계산한 예약 가능 시간대 조회 (GET /v2/bookings/shops/{shopId}/available-times).
 * 게임수·인원·날짜가 바뀔 때마다 재조회한다.
 * 응답: data.{playMinutes, availableTimes: [{startTime, playEndTime, occupyEndTime, roomIds}]}
 */
export const getAvailableBookingTimes = async (
  shopId: string,
  params: {
    date: string; // YYYY-MM-DD (KST)
    holeCnt: number; // 게임 홀 수 (기본 18)
    game: number; // 게임 수 (기본 1)
    person: number; // 인원 수 (기본 1)
    leftHanded: boolean; // 좌타 여부 (기본 false)
    immediateOnly: boolean; // 매장 즉시확정(shop.immediateBookable) 여부
  },
) => {
  const response = await http.get(`/v2/bookings/shops/${shopId}/available-times`, {
    params,
    baseURL: getBookingApiOrigin(),
  });
  return response;
};

export const postReadyBooking = async (payload: any) => {
  const response = await http.post(`/bookings/ready`, payload);
  return response;
};

export const postBooking = async (payload: any) => {
  const response = await http.post(`/bookings/confirm`, payload);
  return response;
};

export const cancelBooking = async (payload: any) => {
  const response = await http.post(`/bookings/cancel`, payload);
  return response;
};
